"use client";

import React from "react";
import { Search, X } from "lucide-react";

interface SupportInboxSearchProps {
  query: string;
  onQueryChange: (value: string) => void;
  /** Thread search is hidden on mobile once a thread is open, to reclaim space. */
  visibleOnMobile: boolean;
}

/** Client-side thread search box for the Support Inbox tab. */
export function SupportInboxSearch({
  query,
  onQueryChange,
  visibleOnMobile,
}: SupportInboxSearchProps) {
  return (
    <div className={visibleOnMobile ? "block" : "hidden md:block"}>
      <div className="relative">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Search support email…"
          aria-label="Search support email"
          className="h-9 w-full rounded-md border border-border bg-background pl-8 pr-8 text-sm outline-none placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring"
        />
        {query && (
          <button
            type="button"
            onClick={() => onQueryChange("")}
            aria-label="Clear search"
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded-sm p-0.5 text-muted-foreground hover:text-card-foreground"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
